/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreatedAt/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function CreatedAt({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/TxPlanNotes/Content/Content/All/Content/Notes/Content/Note/Author/CreatedAt"
  
}) {
let txPlanNoteSysCreatedValueData = fromData.useDataFormat({ viewPath,
context: 'tx_plan_note',
path: 'sys_created',
format: fromHelpers.formatDateTime,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tx_plan_note.sys_created"
 format="helpers.js formatDateTime"
 text={txPlanNoteSysCreatedValueData}
 color={dtColorsNeutral500}
/>
{children}
</React.Fragment>)
}